import axios from "axios";
import { store } from "../store";
import { ApprovalGroupsCompanies, CompanyEmployees, ModifyApprovalGroup, ModifyNotificationGroup, SaveApprovalGroup, SaveNotificationGroup } from "../interfaces/auth.interface";
import { Employee, Office } from "../interfaces/s10Corporation.interface";
import { setupInterceptors } from "../utils/requests";
import { Location } from "../views/my-potal/attendance";
import { SaveLicenseEmployeeRequest } from "../views/management/licences";


const s10ClockApi = axios.create({
    baseURL: `${process.env.REACT_APP_MODULES_S10_API}/Clock/api/`,
	headers: {
		moduleId: process.env.REACT_APP_MODULE_ID,
	}
})

const s10OrganizationApi = axios.create({
    baseURL: `${process.env.REACT_APP_MODULES_S10_API}/Organization/api/`,
	headers: {
		moduleId: process.env.REACT_APP_MODULE_ID,
	}
})

const s10CentralnApi = axios.create({
    baseURL: `${process.env.REACT_APP_MODULES_S10_API}/Central/api/`,
	headers: {
		moduleId: process.env.REACT_APP_MODULE_ID,
	}
})

const s10LicensesApi = axios.create({
    baseURL: `${process.env.REACT_APP_S10_LICENSES_API}`,
	headers: {
		moduleId: process.env.REACT_APP_MODULE_ID,
	}
})

s10ClockApi.interceptors.response.use((config) => config, setupInterceptors);
s10OrganizationApi.interceptors.response.use((config) => config, setupInterceptors);
s10CentralnApi.interceptors.response.use((config) => config, setupInterceptors);


export const getOfficesByCompanyCode = async (token: string, companyCode: string) => {
	const headers = {
		token,
	};
	
	const result = await s10OrganizationApi.get( 
		`OfficeApi/PrincipalOfficeByCompany?companyCode=${companyCode}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getNotificationGroups = async (companyCode: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`NotificationGroupApi/NotificationGroupToList?companyRUC=${companyCode}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getNotificationGroupEmployees = async (notificationGroupId: number) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`NotificationReceiverApi/ToListByNotificationGroup?notificationGroupId=${notificationGroupId}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getApprovalGroups = async (companyCode: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`ApprovalGroupApi/ApprovalGroupToList?companyCode=${companyCode}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getNotificationsGroups = async (companyCode: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`NotificationGroupApi/NotificationGroupToListByCompany?companyCode=${companyCode}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const saveNotificationGroups = async ({Name, Type, CompanyCode}: SaveNotificationGroup) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {Name, Type, CompanyCode}
	const result = await s10OrganizationApi.post( 
		'NotificationGroupApi/InsertNotificationGroup',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const saveApprovalGroups = async ({Name, ApproversNumber, NotificationGroupId, CompanyCode}: SaveApprovalGroup) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {Name, ApproversNumber, NotificationGroupId, CompanyCode}
	const result = await s10OrganizationApi.post( 
		'ApprovalGroupApi/InsertApprovalGroup',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const modifyApprovalGroups = async ({Name, ApproversNumber, NotificationGroupId, Id}: ModifyApprovalGroup) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {Name, ApproversNumber, NotificationGroupId, Id}
	const result = await s10OrganizationApi.post( 
		'ApprovalGroupApi/UpdateApprovalGroup',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const modifyNotificationGroups = async ({Name, Type, Id}: ModifyNotificationGroup) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {Name, Type, Id}
	const result = await s10OrganizationApi.post( 
		'NotificationGroupApi/UpdateNotificationGroup',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const deleteNotificationGroups = async ({ids}: {ids: string[]}) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {ids}
	const result = await s10OrganizationApi.post( 
		'NotificationGroupApi/DeleteNotificationGroup',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const deleteApprovalGroups = async ({ids}: {ids: string[]}) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {ids}
	const result = await s10OrganizationApi.post( 
		'ApprovalGroupApi/DeleteApprovalGroup',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getApprovalResponsables = async (ApprovalGroupId: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`ApprovalGroupApi/ApprovalResponsablesToList?approvalGroupId=${ApprovalGroupId}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const setApprovalResponsables = async (ApprovalGroupId: string, responsables: string[]) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		ApprovalGroupId,
		Responsables: responsables.map(r => ({EmployeeCode: r})),
	}
	const result = await s10OrganizationApi.post( 
		'ApprovalGroupApi/InsertApprovalGroupResponsable',
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const setApprovalEmployees = async (ApprovalGroupId: string, employeesCodes: string[]) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		ApprovalGroupId,
		Employees: employeesCodes.map(r => ({EmployeeCode: r})),
	}
	const result = await s10OrganizationApi.post( 
		'ApprovalGroupApi/InsertApprovalGroupEmployee',
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => {
			console.log(e)
			return e
		});
	return result
}

export const setNotificationGroupEmployees = async (NotificationGroupId: number, employeesCodes: string[]) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		NotificationGroupId,
		Receivers: employeesCodes.map(r => ({EmployeeCode: r})),
	}
	const result = await s10OrganizationApi.post( 
		'NotificationReceiverApi/InsertNotificationReceiver',
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => {
			console.log(e)
			return e
		});
	return result
}

export const deleteResponsables = async ({ids}: {ids: string[]}) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {ids}
	const result = await s10OrganizationApi.post( 
		'ApprovalGroupApi/DeleteApprovalGroupResponsable',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getApprovalEmployees = async (ApprovalGroupId: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`ApprovalGroupApi/ApprovalEmployeesToList?approvalGroupId=${ApprovalGroupId}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const deleteEmployees = async ({ids}: {ids: string[]}) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {ids}
	const result = await s10OrganizationApi.post( 
		'ApprovalGroupApi/DeleteApprovalGroupEmployee',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const deleteOrganizationGroupEmployees = async ({ids}: {ids: string[]}) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {ids}
	const result = await s10OrganizationApi.post( 
		'NotificationReceiverApi/DeleteNotificationReceiver',
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e);
	return result
}



export const notifyUnapprovedPost = async (sampleText: string) => {
	const {companyselected, sessionData} = store.getState().auth;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		Code: companyselected?.Code,
		Email: sessionData?.UserName,
		SampleText: sampleText || ''
	};
	const result = await s10OrganizationApi.post( 
		"NotificationReceiverApi/NotifyUnapprovedPost",
		data,
		{headers},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const getCorporationCompanies = async () => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10CentralnApi.get( 
		`/CompanyApi/ToListByCorporation?corporationId=${companyselected?.CorporationId}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getOfficesByCompanyRuc = async (companyRuc: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`OfficeApi/OfficeToListByCompany?companyCode=${companyRuc}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const setOrganizationEmployee = async (officeId: Office['Id'], IsPrincipal: boolean, employees: CompanyEmployees['CodIdentificador'][]) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		OfficeId: officeId,
		IsPrincipal: IsPrincipal,
		Employees: employees
	};
	const result = await s10OrganizationApi.post( 
		`OfficeApi/OfficeEmployeeInsert`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const deleteOrganizationEmployee = async (employeesIds: Employee['Id'][]) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		Ids: employeesIds,
	};
	const result = await s10OrganizationApi.post( 
		`OfficeApi/OfficeEmployeeDelete`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const setOrganizationOffice = async (companyData: ApprovalGroupsCompanies, parentId: Office['Id'], name: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		Name: name,
		IsActive: true,
		ParentId: parentId,
		// CompanyId: 1062,  
		CompanyCode: companyData.RUC,
		Responsables: null,
	};
	console.log(data)
	const result = await s10OrganizationApi.post( 
		`OfficeApi/OfficeInsert`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const setOrganizationOfficeNewName = async (id: Office['Id'], name: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = {
		Name: name,
		Id: id,
	};
	const result = await s10OrganizationApi.post( 
		`OfficeApi/OfficeEditName`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const deleteOrganizationOffice = async (officeId: Office['Id']) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10OrganizationApi.get( 
		`OfficeApi/OfficeDelete?officeId=${officeId}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}


export const getInMyChangeOfficesByEmployeeCode = async () => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	
	const result = await s10OrganizationApi.get( 
		`OfficeApi/GetOfficePrincipalCompanies?employeeCode=${authCompanySelectedState?.Code}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getEmployeesInMyCharge = async (rucSelected: string) => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const url = `OfficeApi/OfficeEmployeeToListByPrincipal/?employeeCode=${authCompanySelectedState?.Code}&companyRUC=${rucSelected}`;
	console.log(url)
	const result = await s10OrganizationApi.get( 
		url,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}


export const getEmployeesToApprove = async () => {
	const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		AccessType: 1,
	};
	const url = `ApprovalGroupApi/ApprovalGroupEmployeesByResponsable/?employeeCode=${authCompanySelectedState?.Code}`;
	console.log(url)
	const result = await s10OrganizationApi.get( 
		url,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getLastAttendance = async () => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10ClockApi.get( 
		`/AttendanceMarkApi/GetLastAttendance?employeeCode=${companyselected?.Code}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getLastAttendanceActivity = async () => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10ClockApi.get( 
		`/AttendanceMarkApi/GetLastAttendanceActivity?employeeCode=${companyselected?.Code}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const addAttendanceActivityMark = async (employeeId: number, dailyActivity: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = { 
		EmployeeId: employeeId, 
		DailyActivities: dailyActivity 
	}
	const result = await s10ClockApi.post( 
		`/AttendanceMarkApi/AddAttendanceActivityMark`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const addRemoteAttendance = async (
	employeeId: number, 
	markType: 1 | 0, 
	location?: Location | null, 
	ipAddress?: string,
	photoS3Url?: string | null
) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const data = { 
		EmployeeId: employeeId,
		MarkType: markType,
		AuthenticationType: 98,
		Latitude: location?.latitude,
		Longitude: location?.longitude,
		IPAddress: ipAddress,
		PhotoKey: photoS3Url,
	}
	const result = await s10ClockApi.post( 
		`/AttendanceMarkApi/AddRemoteAttendance`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getInMyChargeAttendances = async (startTime: string, endTime: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10ClockApi.get( 
		`/AttendanceMarkApi/RemoteAttendanceMarkByResponsable?fechaInicio=${startTime}&fechaFin=${endTime}&employeeCode=${companyselected?.Code}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getMyAttendances = async (startTime: string, endTime: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10ClockApi.get( 
		`/AttendanceMarkApi/RemoteAttendanceMarksByUser?employeeCode=${companyselected?.Code}&fechaInicio=${startTime}&fechaFin=${endTime}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getS10Licenses = async () => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10LicensesApi.get( 
		`/GetCorporationModuleInformation`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getS10LicenseUsers = async (licenseId: string) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10LicensesApi.get( 
		`/GetSecurityUserCorporationModuleByCorporationModuleId?Id=${licenseId}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const getS10LicenseAvailableRoles = async (moduleId: number) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10LicensesApi.get( 
		`/GetSecurityRoleByModuleId?moduleId=${moduleId}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

export const saveS10LicenseEmployees = async (data: SaveLicenseEmployeeRequest) => {
    const companyselected = store.getState().auth.companyselected;
	const headers = {
		token: companyselected?.Token,
	};
	const result = await s10LicensesApi.post( 
		`/RegisterCorporationSecurityAccess`,
		data,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}